<template>
  <div class="goodsTable">
    <!-- 运输载具数据表格 -->
    <vxe-toolbar
      v-if="
        returnStatus != 'ZT02' &&
        returnStatus != 'ZT03' &&
        returnStatus != 'ZT07' &&
        returnStatus != 'ZT08'
      "
    >
      <template v-slot:buttons>
        <vxe-button
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          @click="insertEvent()"
          >{{ $t('returnDetail.btnList.add') }}</vxe-button
        >
        <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="handleDelete('goodsTable')"
          >{{ $t('returnDetail.btnList.remove') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      resizable
      show-overflow
      :data="goodsData"
      :edit-config="editConfig"
      size="mini"
      ref="goodsTable"
      :edit-rules="goodsTableEditRules"
      auto-resize
      :valid-config="{ autoPos: true, message: 'inline' }"
    >
      <vxe-table-column type="checkbox" width="60"></vxe-table-column>
      <vxe-table-column
        type="seq"
        width="60"
        field="returnDetailNo"
        :title="$t('returnDetail.goodsTable.indexTitle')"
      ></vxe-table-column>
      <vxe-table-column
        field="ladingNo"
        width="150"
        :title="this.$t('returnDetail.goodsTable.ladingNo')"
        :edit-render="{
          name: 'input',
          defaultValue: '',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            clearable
            @change="(val) => changeEvent(val, scope.row, scope)"
            class="widthStyle"
            v-model="scope.row['ladingNo']"
            filterable
            remote
            reserve-keyword
            :remote-method="(val) => ladingNoRemote(val, scope.row, scope)"
            :disabled="true"
            :loading="ladingNoLoading"
            @focus="ladingNoRemote(scope.row['ladingNo'], scope.row)"
          >
            <el-option
              v-for="(item, index) in ladingNoOptions"
              :key="item.ladingNo + index"
              :label="item.ladingNo"
              :value="item.ladingNo"
            ></el-option>
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="businessInboundBatchNo"
        width="200"
        :title="$t('returnDetail.goodsTable.businessInboundBatchNo')"
        :edit-render="{ name: 'input' }"
      >
        <template v-slot:edit="scope">
          <SearchModal
            width="800"
            ref="searchModal"
            className="customer-search"
            model="businessInboundBatchNo"
            :placeholder="$t('returnDetail.goodsTable.businessInboundBatchNo')"
            :API="transportList.API"
            :query="transportList.query"
            :extraData="{ exchangeRate: baseData.currencyExchangeRate }"
            :page="true"
            :isMultiple="true"
            :currentValue="scope.row.businessInboundBatchNo"
            :searchColumns="transportList.searchColumns"
            :columnList="transportList.columnList"
            @setSearchModal="(val, select) => setSearchModal(val, select, scope.row, scope)"
          ></SearchModal>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="batchNo"
        width="150"
        :title="this.$t('returnDetail.goodsTable.batchNo')"
      >
      </vxe-table-column>
      <vxe-table-column
        field="productDesc"
        width="150"
        :title="this.$t('returnDetail.goodsTable.productDesc')"
      >
      </vxe-table-column>
      <vxe-table-column
        field="unitName"
        width="150"
        :title="this.$t('returnDetail.goodsTable.unit')"
      ></vxe-table-column>
      <vxe-table-column
        width="150"
        field="ladingDetailNo"
        :title="this.$t('returnDetail.goodsTable.ladingDetailNo')"
      ></vxe-table-column>
      <vxe-table-column
        width="150"
        field="availableReturnQuantity"
        :title="
          type == '0'
            ? this.$t('returnDetail.goodsTable.availableChangeQuantity')
            : this.$t('returnDetail.goodsTable.availableReturnQuantity')
        "
      ></vxe-table-column>
      <vxe-table-column
        width="150"
        field="returnQuantity"
        :title="
          type == '0'
            ? this.$t('returnDetail.goodsTable.changeQuantity')
            : this.$t('returnDetail.goodsTable.returnQuantity')
        "
        :edit-render="{
          name: 'input',
          defaultValue: '',
        }"
      >
        <template v-slot:edit="scope">
          <input-number
            v-model="scope.row['returnQuantity']"
            :max="999999999.999999"
            :min="0"
            :precision="$globalVar.qPoint"
            :clearable="true"
            @input="(val) => calculateQuantity(val, scope.row, scope)"
          ></input-number>
        </template>
      </vxe-table-column>
      <vxe-table-column
        width="150"
        field="actualSendQuantity"
        v-if="type == '0'"
        :title="this.$t('returnDetail.goodsTable.actualSendQuantity')"
        :edit-render="{
          name: 'input',
          defaultValue: '',
        }"
      >
        <template v-slot:edit="scope">
          <input-number
            :disabled="scope.row['sendDis']"
            v-model="scope.row['actualSendQuantity']"
            :max="99999999999.999999"
            :clearable="true"
            :precision="$globalVar.qPoint"
          ></input-number>
        </template>
      </vxe-table-column>
      <vxe-table-column
        width="150"
        field="actualInboundQuantity"
        :title="this.$t('returnDetail.goodsTable.actualInboundQuantity')"
        :edit-render="{
          name: 'input',
          defaultValue: '',
        }"
      >
        <template v-slot:edit="scope">
          <input-number
            :disabled="!(returnStatus == 'ZT07' && isDirectDeliver == 1)"
            v-model="scope.row['actualInboundQuantity']"
            :max="99999999999.999999"
            :clearable="true"
            :precision="$globalVar.qPoint"
          ></input-number>
        </template>
      </vxe-table-column>
      <vxe-table-
        width="150"
        field="ladingQuantity"
        :title="this.$t('returnDetail.goodsTable.ladingDetailNo')"
        v-if="false"
      ></vxe-table->
      <vxe-table-column
        width="150"
        field="contractUnitPrice"
        :title="this.$t('returnDetail.goodsTable.contractUnitPrice')"
      >
        <template v-slot="scope">
          <div v-if="baseData.currencyExchangeRate == 1">
            {{ toFixedNumber(scope.row.contractUnitPrice, 2) }}
          </div>
          <div v-else>
            <p class="break-space" v-if="scope.row.contractUnitPrice">
              {{ scope.row.contractUnitPrice ? $t('contractAgency.productTab.originCoin') : null }}
              {{ toFixedNumber(scope.row.contractUnitPrice, 2) }}
            </p>
            <p class="break-space" v-if="scope.row['contractUnitPriceLocal']">
              {{
                scope.row['contractUnitPriceLocal']
                  ? $t('contractAgency.productTab.localCoin')
                  : null
              }}
              {{ toFixedNumber(scope.row['contractUnitPriceLocal'], 2) }}
            </p>
          </div>
        </template>
      </vxe-table-column>
      <!-- 退货单价/元 -->
      <vxe-table-column
        width="150"
        field="returnUnitPrice"
        :title="this.$t('returnDetail.goodsTable.returnUnitPrice')"
        :edit-render="{
          name: 'input',
          defaultValue: '',
        }"
      >
        <template v-slot:edit="scope">
          <input-number
            v-model="scope.row['returnUnitPrice']"
            :max="99999999999.999999"
            :precision="$globalVar.pPoint"
            :clearable="true"
            @input="(val) => calculate(val, scope.row, scope)"
          ></input-number>
        </template>
        <template v-slot="scope">
          <div v-if="baseData.currencyExchangeRate == 1">
            {{ toFixedNumber(scope.row.returnUnitPrice, 2) }}
          </div>
          <div v-else>
            <p class="break-space" v-if="scope.row.returnUnitPrice">
              {{ scope.row.returnUnitPrice ? $t('contractAgency.productTab.originCoin') : null }}
              {{ toFixedNumber(scope.row.returnUnitPrice, 2) }}
            </p>
            <p class="break-space" v-if="scope.row['returnUnitPriceLocal']">
              {{
                scope.row['returnUnitPriceLocal'] ? $t('contractAgency.productTab.localCoin') : null
              }}
              {{ toFixedNumber(scope.row['returnUnitPriceLocal'], 2) }}
            </p>
          </div>
        </template>
      </vxe-table-column>
      <!-- 金额 -->
      <vxe-table-column
        width="150"
        field="returnMoneyAmount"
        :title="this.$t('returnDetail.goodsTable.returnMoneyAmount')"
      >
        <template v-slot="scope">
          <div v-if="baseData.currencyExchangeRate == 1">
            {{ toFixedNumber(scope.row.returnMoneyAmount, 2) }}
          </div>
          <div v-else>
            <p class="break-space" v-if="scope.row.returnMoneyAmount">
              {{ scope.row.returnMoneyAmount ? $t('contractAgency.productTab.originCoin') : null }}
              {{ toFixedNumber(scope.row.returnMoneyAmount, 2) }}
            </p>
            <p class="break-space" v-if="scope.row['returnMoneyAmountLocal']">
              {{
                scope.row['returnMoneyAmountLocal']
                  ? $t('contractAgency.productTab.localCoin')
                  : null
              }}
              {{ toFixedNumber(scope.row['returnMoneyAmountLocal'], 2) }}
            </p>
          </div>
        </template>
      </vxe-table-column>
      <!-- 运费单价 -->
      <vxe-table-column
        width="150"
        field="deliveryExpenseUnitPrice"
        :title="this.$t('returnDetail.goodsTable.deliveryExpenseUnitPrice')"
        :edit-render="{
          name: 'input',
          defaultValue: '',
        }"
      >
        <template v-slot:edit="scope">
          <input-number
            v-model="scope.row['deliveryExpenseUnitPrice']"
            :max="99999999999.999999"
            :clearable="true"
            :precision="$globalVar.pPoint"
            @change="(val) => calculateFee(val, scope.row, scope)"
            @input="(val) => calculate(val, scope.row, scope)"
          ></input-number>
        </template>
        <template v-slot="scope">
          <div v-if="baseData.currencyExchangeRate == 1">
            {{ toFixedNumber(scope.row.deliveryExpenseUnitPrice, 2) }}
          </div>
          <div v-else>
            <p class="break-space" v-if="scope.row.deliveryExpenseUnitPrice">
              {{
                scope.row.deliveryExpenseUnitPrice
                  ? $t('contractAgency.productTab.originCoin')
                  : null
              }}
              {{ toFixedNumber(scope.row.deliveryExpenseUnitPrice, 2) }}
            </p>
            <p class="break-space" v-if="scope.row['deliveryExpenseUnitPriceLocal']">
              {{
                scope.row['deliveryExpenseUnitPriceLocal']
                  ? $t('contractAgency.productTab.localCoin')
                  : null
              }}
              {{ toFixedNumber(scope.row['deliveryExpenseUnitPriceLocal'], 2) }}
            </p>
          </div>
        </template>
      </vxe-table-column>
      <!-- 已开票数量 -->
      <vxe-table-column
        v-if="type == '1'"
        width="150"
        field="invoiceQuantity"
        :title="this.$t('returnDetail.goodsTable.invoiceQuantity')"
      ></vxe-table-column>
      <!-- 未开票数量 -->
      <vxe-table-column
        v-if="type == '1'"
        width="150"
        field="nonInvoiceQuantity"
        :title="this.$t('returnDetail.goodsTable.nonInvoiceQuantity')"
      ></vxe-table-column>
      <!-- 已开票金额 -->
      <vxe-table-column
        v-if="type == '1'"
        width="150"
        field="invoiceAmount"
        :title="this.$t('returnDetail.goodsTable.invoiceAmount')"
      ></vxe-table-column>
    </vxe-table>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import SearchTable from '@/components/form-item/search-table';
  import InputNumber from '@/components/form-item/input-number';
  import GOODS_API from '@/api/masterData/goods';
  // import COOPERATION_API from '@/api/masterData/cooperation';
  // import MASTER_API from '@/api/masterData/company.js';
  import API from '@/api/purchaseSalesCenter/salesReturnsAndExchange';
  import SearchModal from '@/components/SearchModal';
  // import { resolve, reject } from 'q';
  import { toFixedNumber } from '@/common/js/util';

  export default {
    name: 'returnAdd',
    components: {
      // SearchTable,
      InputNumber,
      SearchModal,
    },
    props: ['type', 'baseFormReturnCompanyCode', 'baseData'],
    data() {
      return {
        baseFormReturnCompanyCodes: null,
        returnStatus: '',
        isDirectDeliver: '',
        goodsData: [],
        editConfig: { trigger: 'click', mode: 'row', showStatus: true },
        ladingNoLoading: false,
        ladingNoOptions: [], //提货仓库下拉数据
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      //业务入库批次
      transportList() {
        return {
          width: '800',
          API: API.LIST_STORAGE_LADE,
          query: {
            storageNo: this.baseData.outboundStorageNo || '',
            ladingNo: '',
            businessInboundBatchNo: '',
          },
          searchColumns: [
            {
              name: this.$t('returnDetail.businessInbound.ladingNo'),
              prop: 'ladingNo',
              type: 'input',
              maxlength: '30',
            },
            {
              name: this.$t('returnDetail.businessInbound.businessInboundBatchNo'),
              prop: 'businessInboundBatchNo',
              type: 'input',
              maxlength: '30',
            },
          ],
          columnList: [
            {
              prop: 'ladingNo',
              label: this.$t('returnDetail.businessInbound.ladingNo'),
              width: '90',
            },
            {
              prop: 'ladingDetailNo',
              label: this.$t('returnDetail.businessInbound.ladingDetailNo'),
              width: '95',
            },
            {
              prop: 'businessInboundBatchNo',
              label: this.$t('returnDetail.businessInbound.businessInboundBatchNo'),
              width: '105',
            },
            {
              prop: 'availableReturnQuantity',
              label: this.$t('returnDetail.businessInbound.availableReturnQuantity'),
              width: '85',
            },
            {
              prop: 'pickingQuantity',
              label: this.$t('returnDetail.businessInbound.pickingQuantity'),
              width: '75',
            },
            {
              prop: 'productNo',
              label: this.$t('returnDetail.businessInbound.productNo'),
              width: '80',
            },
            {
              prop: 'productDesc',
              label: this.$t('returnDetail.businessInbound.productDesc'),
              width: '180',
            },
            {
              prop: 'unitName',
              label: this.$t('returnDetail.businessInbound.unitName'),
            },
            {
              prop: 'businessContractUnitPrice',
              label: this.$t('returnDetail.businessInbound.businessContractUnitPrice'),
            },
          ],
        };
      },
      goodsTableEditRules() {
        return {
          productDesc: [
            {
              required: true,
              message: this.$t('returnDetail.goodsTableEditRules.productDesc'),
            },
          ],
          ladingNo: [
            {
              required: true,
              message: this.$t('returnDetail.goodsTableEditRules.ladingNo'),
            },
          ],
          returnQuantity: [
            {
              required: true,
              message: this.$t('returnDetail.goodsTableEditRules.returnQuantity'),
            },
          ],
          returnUnitPrice: [
            {
              required: true,
              message: this.$t('returnDetail.goodsTableEditRules.returnUnitPrice'),
            },
          ],
        };
      },
    },
    mounted() {
      this.baseFormReturnCompanyCodes = this.baseFormReturnCompanyCode || 'CNY';
    },
    watch: {
      baseFormReturnCompanyCode(newValue) {
        this.baseFormReturnCompanyCodes = newValue;
      },
    },
    methods: {
      toFixedNumber,
      getDetail(allDetail) {
        this.returnStatus = allDetail.returnStatus;
        this.isDirectDeliver = allDetail.isDirectDeliver;
        console.log(allDetail.returnStatus);
        console.log(allDetail.returnStatus == 'ZT03' && !this.$route.query.isCopy);
        console.log(allDetail.returnStatus == 'ZT02' && !this.$route.query.isCopy);
        this.editConfig =
          (allDetail.returnStatus == 'ZT03' && !this.$route.query.isCopy) ||
          (allDetail.returnStatus == 'ZT02' && !this.$route.query.isCopy)
            ? {}
            : { trigger: 'click', mode: 'row' };
        this.goodsData = allDetail.orderSalesReturnDetails;
        let nonInvoiceQuantityList = [];
        let invoiceAmountList = [];
        allDetail.orderSalesReturnDetails.map((item) => {
          // if (
          //   item.actualInboundQuantity != "" &&
          //   item.actualInboundQuantity != undefined
          // ) {
          //   this.goodsData[index].sendDis = true;
          // } else {
          //   this.goodsData[index].sendDis = false;
          // }
          if (this.$route.query.isCopy) {
            item.returnQuantity = 0;
            item.actualInboundQuantity = 0;
          }
          nonInvoiceQuantityList.push(item.nonInvoiceQuantity || 0);
          invoiceAmountList.push(item.invoiceAmount || 0);
        });
        Promise.resolve(this.calculateAdd(nonInvoiceQuantityList)).then((res) => {
          this.$emit('calculateNonInvoiceQuantity', res);
        });
        Promise.resolve(this.calculateAdd(invoiceAmountList)).then((res) => {
          this.$emit('calculateInvoiceAmount', res);
        });
      },
      getTableData() {
        return this.$refs.goodsTable.getTableData().fullData;
      },
      throwData() {
        this.$emit('throwData', this.$refs.goodsTable.getTableData().fullData);
      },
      // 载具表格新增一行载具表格新增一行
      insertEvent() {
        this.$emit('insertEvent');
        if (!this.baseData.returnDepartmentCode) {
          return this.$message({
            showClose: true,
            message: this.$t('returnDetail.msg.returnDepartmentCode'),
            type: 'error',
          });
        }
        if (!this.baseData.purchaseUnitNo) {
          return this.$message({
            showClose: true,
            message: this.$t('returnDetail.msg.purchaseUnitNo'),
            type: 'error',
          });
        }
        if (!this.baseData.contractNo) {
          return this.$message({
            showClose: true,
            message: this.$t('returnDetail.msg.contractNo'),
            type: 'error',
          });
        }
        if (!this.baseData.outboundStorageName) {
          return this.$message({
            showClose: true,
            message: this.$t('returnDetail.baseForm.outboundStorageNoPlaceholder'),
            type: 'error',
          });
        }
        this.$refs.goodsTable.validate((valid) => {
          if (valid) {
            const record = {
              nameVoyageLicense: null,
              freightInformation: null,
              contactPerson: null,
              contactPhoneNo: null,
              identityCardNumber: null,
              invoiceQuantity: 0,
            };
            this.$refs.goodsTable
              .insert(record)
              .then(({ row }) => this.$refs.goodsTable.setActiveRow(row));
            this.throwData();
          }
        });
      },
      handleDelete(goodsTable) {
        const selectedList = this.$refs[goodsTable].getCheckboxRecords();
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('returnDetail.msg.removeMsg'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs[goodsTable].removeSelecteds();
            this.calculateReturnMoneyAmount();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('personnel.table.deletSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('personnel.table.deletFalse'),
            });
          });
        this.$refs.goodsTable.updateStatus({});
        this.throwData();
      },
      // 接口加法计算
      calculateAdd(adds) {
        return new Promise((resolve, reject) => {
          this.$axios.post(API.GET_ADD_AMOUNT, { adds }).then((res) => {
            if (0 == res.data.code) {
              resolve(res.data.data);
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
              reject();
            }
          });
        });
      },
      calculateQuantity(val, row, scope) {
        // 求所有同提单下同业务批次的已填写的数量和 总可退换货量-已填写的退换货数量总和 = 限制数字
        let numAdds = [];
        this.$refs.goodsTable.getTableData().fullData.map((item) => {
          if (
            item._XID != scope.rowid &&
            scope.row.businessInboundBatchNo == item.businessInboundBatchNo &&
            scope.row.ladingNo == item.ladingNo &&
            scope.row.ladingDetailNo == item.ladingDetailNo
          ) {
            numAdds.push(item.returnQuantity);
          }
        });
        Promise.resolve(this.calculateAdd(numAdds)).then((res) => {
          // 计算总数量
          let limitNum = this.$cal.calCommon(row.availableReturnQuantity, res, '-');
          // 限制填写的退换货数量
          if (Number(row.returnQuantity) > limitNum) {
            row.returnQuantity = limitNum;
          }
          let adds = [];
          this.$refs.goodsTable.getTableData().fullData.map((item) => {
            adds.push(!item.returnQuantity ? 0 : item.returnQuantity);
          });
          // if (!this.$route.query.isEdit||this.$route.query.isEdit=="false") {
          row.nonInvoiceQuantity = 0;
          //计算未开票总数
          let nonInvoiceQuantityList = [];
          this.$refs.goodsTable.getTableData().fullData.map((item) => {
            nonInvoiceQuantityList.push(!item.nonInvoiceQuantity ? 0 : item.nonInvoiceQuantity);
          });
          Promise.resolve(this.calculateAdd(nonInvoiceQuantityList)).then((res) => {
            this.$emit('calculateNonInvoiceQuantity', res);
          });
          // }
          Promise.resolve(this.calculateAdd(adds)).then((res) => {
            // 计算总数量
            this.$emit('calculateQuantity', res);
          });
          let addList = [];
          this.$refs.goodsTable.getTableData().fullData.map((item) => {
            addList.push(
              !item.returnQuantity || !item.deliveryExpenseUnitPrice
                ? 0
                : item.deliveryExpenseUnitPrice * item.returnQuantity
            );
          });
          Promise.resolve(this.calculateAdd(addList)).then((res) => {
            // 计算总数量
            this.$emit('calculateFee', res);
          });
          // 数量更改，要计算金额
          this.calculate(val, row, scope);
        });
      },
      // 计算运费
      calculateFee() {
        let adds = [];
        this.$refs.goodsTable.getTableData().fullData.map((item) => {
          adds.push(
            item.deliveryExpenseUnitPrice == ''
              ? 0
              : item.deliveryExpenseUnitPrice * item.returnQuantity
          );
        });
        Promise.resolve(this.calculateAdd(adds)).then((res) => {
          // 计算总数量
          this.$emit('calculateFee', res);
        });
      },
      // 计算每列的金额
      calculate(val, row, scope) {
        const params = {
          returnQuantity: row.returnQuantity ? row.returnQuantity : 0,
          returnUnitPrice: row.returnUnitPrice ? row.returnUnitPrice : 0,
          deliveryExpenseUnitPrice: row.deliveryExpenseUnitPrice ? row.deliveryExpenseUnitPrice : 0,
          currencyExchangeRate: this.baseData.currencyExchangeRate,
        };
        this.$axios.post(API.GET_RETURN_MONEY_AMOUNT, params).then((res) => {
          if (0 == res.data.code) {
            row.returnMoneyAmount = res.data.data.returnMoneyAmount; // 退换货金额
            row.returnMoneyAmountLocal = res.data.data.returnMoneyAmountLocal; //退换货金额本币
            row.returnUnitPriceLocal = res.data.data.returnUnitPriceLocal; //退换货金额本币
            row.deliveryExpenseUnitPriceLocal = res.data.data.deliveryExpenseUnitPriceLocal;
            this.$refs.goodsTable.updateStatus(scope);
            this.calculateReturnMoneyAmount();
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      // 计算总金额
      calculateReturnMoneyAmount() {
        let adds = [];
        this.$refs.goodsTable.getTableData().fullData.map((item) => {
          adds.push(item.returnMoneyAmount);
        });
        Promise.resolve(this.calculateAdd(adds)).then((res) => {
          this.$emit('calculate', res);
        });
      },
      //获取值
      chooseTable(val, row, field, scope) {
        if (field == 'productDesc') {
          if (val) {
            const productDesc = `${val[0].detailProductDisplayName}${val[0].detailProductModel}`;
            row.productDesc = productDesc;
            row.productNo = val[0].productDetailCode;
            row.unit = val[0].basicUnit || null;
            row.unitName = val[0].basicUnitName || null;
            let flag = false;
            // 重新选择商品时，要重新选择提货单号
            if (row.ladingNo) {
              this.ladingNoOptions.map((item) => {
                if (item.productNo == row.productNo) {
                  flag = true;
                }
              });
              if (!flag) {
                this.ladingNoOptions = [];
                row.ladingNo = null;
                row.unit = '';
                row.ladingDetailNo = '';
                row.availableReturnQuantity = '';
                row.contractUnitPrice = '';
                row.returnQuantity = '';
                row.returnUnitPrice = '';
                row.returnMoneyAmount = '';
              }
            } else {
              this.ladingNoOptions = [];
              row.ladingNo = null;
              row.unit = '';
              row.ladingDetailNo = '';
              row.availableReturnQuantity = '';
              row.contractUnitPrice = '';
              row.returnQuantity = '';
              row.returnUnitPrice = '';
              row.returnMoneyAmount = '';
            }
            this.calculateQuantity(val, row, scope);
          } else {
            row.productDesc = '';
            row.productNo = '';
            row.unit = '';
            row.unitName = '';
          }
        }
        this.$refs.goodsTable.updateStatus(scope);
      },
      updateStatus() {
        this.goodsData = [];
        this.$refs.goodsTable.updateStatus();
      },
      // 提货单号选择触发
      changeEvent(val, row, scope) {
        this.setSearchModal(val, null, row, scope);
        if (val) {
          Promise.resolve(this.getladingNo(val, row.productNo)).then((res) => {
            if (res.length) {
              // let resData = res;
              // row.ladingQuantity = resData[0].ladingQuantity;
              // row.contractNo = resData[0].contractNo;
              // row.contractDetailNo = resData[0].contractDetailNo;
              // row.unit = resData[0].ladingUnit;
              // row.ladingDetailNo = resData[0].ladingDetailNo;
              // row.contractUnitPrice = resData[0].businessContractUnitPrice;
              // row.returnUnitPrice = resData[0].businessChangingUnitPrice;//提单的变动价格
              // row.taxCode=resData[0].taxCode;
              // row.taxRate=resData[0].taxRate;
              this.$refs.goodsTable.updateStatus(scope);
              if (res[0].ladingCurrency !== this.baseFormReturnCompanyCodes) {
                let params = {
                  fromCurrencyCode: res[0].ladingCurrency,
                  toCurrencyCode: this.baseFormReturnCompanyCodes,
                  contractUnitPrice: res[0].businessContractUnitPrice,
                };
                this.$axios
                  .post(GOODS_API.GET_EXCHANGE_CURRENCY, params)
                  .then((res) => {
                    if (res.data.code == 0) {
                      // row.contractUnitPrice = res.data.data.contractUnitPrice;
                      row.returnUnitPrice = res.data.data.contractUnitPrice;
                      this.$refs.goodsTable.updateStatus(scope);
                    } else {
                      this.goodsData = this.goodsData.filter((item) => {
                        return item._XID != row._XID;
                      });
                      this.$refs.goodsTable.updateStatus(scope);
                      this.$alert(this.$t('businessReceiptList.table.pleaseMakeExchangeRate'));
                    }
                  })
                  .finally(() => {
                    // this.getavailableReturnQuantity(res,row);
                  });
              } else {
                // this.getavailableReturnQuantity(res,row);
              }
            }
          });
        }
      },
      //业务入库批次
      setSearchModal(val, select, row, scope) {
        row.businessInboundBatchNo = select ? select[0].businessInboundBatchNo : '';
        row.productNo = select ? select[0].productNo : '';
        row.productDesc = select ? select[0].productDesc : '';
        row.ladingQuantity = select ? select[0].pickingQuantity : '';
        row.ladingNo = select ? select[0].ladingNo : '';
        row.contractNo = select ? select[0].contractNo : '';
        row.contractDetailNo = select ? select[0].contractDetailNo : '';
        row.unit = select ? select[0].unit : '';
        row.unitName = select ? select[0].unitName : '';
        row.ladingDetailNo = select ? select[0].ladingDetailNo : '';
        row.contractUnitPrice = select ? select[0].businessContractUnitPrice : '';
        row.contractUnitPriceLocal = select ? select[0].businessContractUnitPriceOther : '';
        row.returnUnitPrice = select ? select[0].businessChangingUnitPrice : ''; //提单的变动价格
        row.taxCode = select ? select[0].taxCode : '';
        row.taxRate = select ? select[0].taxRate : '';
        row.availableReturnQuantity = select ? select[0].availableReturnQuantity : '';
        row.storageNo = select ? select[0].storageNo : ''; //仓库
        this.calculateQuantity(val, row, scope);
      },
      //获取可以退货数
      getavailableReturnQuantity(res, row) {
        let orderSalesReturns = [];
        orderSalesReturns.push({
          availableReturnQuantity: res[0].pickingQuantity,
          ladingNo: row.ladingNo,
          ladingDetailNo: res[0].ladingDetailNo,
          businessInboundBatchNo: res[0].businessInboundBatchNo,
        });
        this.$axios.post(API.GET_LADING_NO_SUM, { orderSalesReturns }).then((res) => {
          if (res.data.code == 0) {
            row.availableReturnQuantity = res.data.data[0].returnQuantity;
            this.$refs.goodsTable.updateStatus(row);
          }
        });
      },
      //提货单号下拉数据
      ladingNoRemote(query, row) {
        if (query != '') {
          Promise.resolve(this.getladingNo(query, row.productNo)).then((res) => {
            if (res.length) {
              this.ladingNoOptions = res;
            } else {
              this.ladingNoOptions = [];
            }
          });
        } else {
          this.ladingNoOptions = [];
        }
      },
      // 查找提单号列表和详情
      getladingNo(ladingNo, productNo) {
        return new Promise((resolve, reject) => {
          const params = {
            listStatus: ['TDZT07', 'TDZT03'],
            ladingNo,
            productNo,
            customerNo: this.baseData.purchaseUnitNo,
            ladingBusinessDepartmentNo: this.baseData.returnDepartmentCode,
            contractNo: this.baseData.contractNo,
          };
          this.$axios.post(API.LIST_STORAGE_LADE_TO_PEPLACEMENT, params).then((res) => {
            if (0 == res.data.code) {
              resolve(res.data.data);
            } else {
              reject();
            }
          });
        });
      },
      // 返回数据
      exportChildData(btnType) {
        const tableForm = {};
        let orderSalesReturnDetails = [];
        if (this.$refs.goodsTable.getTableData().fullData.length) {
          this.$refs.goodsTable.getTableData().fullData.map((item, index) => {
            orderSalesReturnDetails.push({
              ...item,
              returnDetailNo: index + 1,
            });
          });
        }
        tableForm.orderSalesReturnDetails = orderSalesReturnDetails;
        if (btnType == 'ZT02') {
          // 点击提交，走校验
          if (tableForm.orderSalesReturnDetails.length == 0) {
            this.$message({
              showClose: true,
              message: this.$t('returnDetail.msg.goodsMsg'),
              type: 'error',
            });
            return false;
          } else {
            return new Promise((resolve, reject) => {
              this.$refs['goodsTable'].validate((valid) => {
                valid ? resolve(tableForm) : reject();
              });
            });
          }
        } else {
          return tableForm;
        }
      },
    },
  };
</script>
